import { ChartData } from "../dataset-window/types";
import { IDataSet, PlotDataEx } from "./interfaces";
import { convertValue } from "./utils";

export const configPieChartData = (data: { values: Array<number>; labels: Array<string> }, selectedColorPalette: Array<string>) => {
  return [createPlotData(data, selectedColorPalette)];
};

const createPlotData = (d: { values: Array<number>; labels: Array<string> }, selectedColorPalette: Array<string>): PlotDataEx => {
  const plotData = {
    labels: d?.labels,
    values: d?.values,
    type: "pie",
    showlegend: true,
    // hovertemplate: `<b>%{y:.3f}</b> at %{x} <br>${d.title}<extra></extra>`,
    //hoverinfo: 'label+percent',
    textinfo: "value+percent",
    textposition: "inside",
    marker: {
      colors: selectedColorPalette,
    },
    hole: 0.4,
  } as PlotDataEx;
  return plotData;
};

/* const createPlotDataArr = (data:  { values: Array<number>; labels: Array<string> },  selectedColorPalette: Array<string>): Array<PlotDataEx> => {
  const plotDataArr: Array<PlotDataEx> = data.map((d: ChartData, index: number) => {
    return createPlotData(d, selectedColorPalette[index]);
  });

  for (const [values, labels] of Object.entries(data)) {
    
  }

  return plotDataArr;
};
 */
